/**
 * Layout content component for vertical layout.
 * Wraps main content with page transition animations.
 */

// Third-party Imports
import classnames from 'classnames';

// Type Imports
import type { ChildrenType } from '@core/types';

// Hook Imports
import { useSettings } from '@core/hooks/useSettings';

// Util Imports
import { verticalLayoutClasses } from '@layouts/utils/layoutClasses';

// Styled Component Imports
import StyledMain from '@layouts/styles/shared/StyledMain';

// Animation
import { PageTransition } from '../../../components/common/PageTransition';

/**
 * Layout content component with page transitions
 */
const LayoutContent = ({ children }: ChildrenType) => {
  const { settings } = useSettings();

  const contentCompact = settings.contentWidth === 'compact';
  const contentWide = settings.contentWidth === 'wide';

  return (
    <StyledMain
      isContentCompact={contentCompact}
      className={classnames(verticalLayoutClasses.content, 'flex-auto', {
        [`${verticalLayoutClasses.contentCompact} is-full`]: contentCompact,
        [verticalLayoutClasses.contentWide]: contentWide,
      })}
    >
      <PageTransition>
        {children}
      </PageTransition>
    </StyledMain>
  );
};

export default LayoutContent;
